type InfoEvalPerformanceProps ={
    namePerformance:string,    
    periodo:string,    
    description:string
  }
    
 const InfoEvalPerformance = ({namePerformance,periodo,description}:InfoEvalPerformanceProps) => {
  return (
    <div className="containerInfoEvalPerformanceQual">
        <div><span className="titleInfoEvalPerformanceQual">{namePerformance}</span> </div>  
        <div><span className="periodInfoEvalPerformanceQual">{description}</span></div>
        <div><span className="periodInfoEvalPerformanceQual">Período: {periodo}</span></div>     
        
    </div>
  )
}

export default InfoEvalPerformance